import { render, staticRenderFns } from "./FactorDetail.vue?vue&type=template&id=39adcb9c&lang=pug"
import script from "./FactorDetail.vue?vue&type=script&lang=js"
export * from "./FactorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports